import React from "react";
import ChartSidebarAccordion from "../ChartSidebarAccordion";
import { useSelector } from "react-redux";
import { Typography } from "@material-ui/core";
import useStyles from "../Styles";
import { areaChartAboutVisualText } from "../AboutSidebar/AboutTexts";
import useGeneratedEntityAboutText from "hooks/useGeneratedEntityAboutText";

function AreaChartAboutTab() {
  const { city_selected, area_chart_tab, tribe_selected, western_arizona_selected, is_tribe, is_city, is_western } =
    useSelector((state) => state.technical_view);
  const classes = useStyles();

  const aboutText = useGeneratedEntityAboutText();
  const selectedText = is_western? western_arizona_selected?.name : city_selected?.name
  return (
    <>
      <ChartSidebarAccordion
        group_name={"About the Visual"}
        accordion_name={'about'}
      >
        <Typography
            variant="body2"
            component="p"
            className={classes.aboutContent}
            style= {{fontSize: '14px'}}
          >
            {
              areaChartAboutVisualText(area_chart_tab, selectedText)
            }
        </Typography>
      </ChartSidebarAccordion>
      {
      area_chart_tab.label === "Entity"&& 
      <ChartSidebarAccordion 
      group_name={`Entity: ${is_tribe? tribe_selected.name : is_city? city_selected.name : is_western ? western_arizona_selected.name : ""}`}
      accordion_name={'entity'}
      >
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutContent}
        >
          {
            area_chart_tab.label === "State"
            ? "placeholder" // TODO : check what the description would be
            : aboutText
          }
        </Typography>
      </ChartSidebarAccordion> 
    }
      {/* <ChartSidebarAccordion
        group_name={`Scenario`}
      >
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutScenarioTitle}
        >
          Name of Scenario
        </Typography>
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutScenario}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim venia, quis nostrud exercitation ullamco labo is nisi ut aliquip
          ex ea com.
        </Typography>
      </ChartSidebarAccordion> */}
    </>
  );
}

export default AreaChartAboutTab;
